import React, { Component } from 'react';
import { connect } from 'react-redux';
import SubHeader from '../../components/SubHeader';
import CarbonFilters from './components/CarbonFilters';
import {
  CarbonEmissionsHeader,
  CardContainer,
  LastUpdateText,
  RenderRightHeader,
  SecondaryContainer,
  StyledButton,
  StyledButtonSecondary,
  Title,
  Wrapper,
} from './styles';
import TruckIcon from './images/truck-icon.png';
import GlobalIcon from './images/global-icon.png';
import ForestIcon from './images/forest-icon.png';
import TrackRedIcon from './images/track-red-icon.png';
import TrackYellowIcon from './images/track-yellow-icon.png';
import TrackGreenIcon from './images/track-green-icon.png';
import DefaultCarbonCard, { CARD_CONDITION_ENUM } from './components/DefaultCarbonCard';
import CarbonTable from './components/CarbonTable';
import { TitleOptions } from './constants/TitleOptions';
import Pagination from '../../components/Pagination';
import { CARBON_RATIO_STATUS } from './constants/CarbonRatioStatus';
import Modal from '../../components/Modal';
import { CancelButton, CarbonCreditModal, CarbonCreditModalButtons, CarbonCreditModalText, DefaultButton } from '../Logged/styles';
import CertificateOfNeutralizationModal from '../../components/CertificateOfNeutralizationModal';
import LoadingIndicator from '../../components/LoadingIndicator';
import { changeFilters, exportCarbonListExcelBase64String, getCarbonEmissionList } from '../../redux/carbon';
import WarningIcon from '../../assets/images/warning-icon.png';
import { RefreshOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { format } from 'date-fns';

class CarbonEmissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paginationOptions: [
        {
          value: 10,
          label: '10',
        },
        {
          value: 25,
          label: '25',
        },
        {
          value: 50,
          label: '50',
        },
      ],
      showCertificateModal: false,
      showCarbonCreditModal: false,
    }
  }

  componentDidMount() {
    this.props.dispatch(getCarbonEmissionList());
  }

  _changePage = (page) => {
    const { dispatch } = this.props;
    const newPage = page;
    dispatch(changeFilters({ page: newPage }));
    window.scrollTo(0, 0);
    dispatch(getCarbonEmissionList({ page: newPage }));
  };

  _reloadPage = (page) => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ page }));
    dispatch(getCarbonEmissionList({ page }));
  };

  _changePageLimit = (amount) => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ page: 0, amount }));
    dispatch(getCarbonEmissionList());
  };

  _toggleShowCertificateModal = () => {
    const { carbonData } = this.props;
    const hasCertificateModalData = carbonData.registration && carbonData.description && carbonData.certificateUrl;

    if (hasCertificateModalData) {
      this.setState({
        showCertificateModal: !this.state.showCertificateModal,
      });
    }
  };

  _toggleShowCarbonCreditModal = () => {
    this.setState({
      showCarbonCreditModal: !this.state.showCarbonCreditModal,
    });
  };

  _carbonCreditTab = () => {
    this._toggleShowCarbonCreditModal();
    window.open('https://viagreen.org.br/compensacao-de-carbono/');
  }

  _handleExportCte = () => {
    const { dispatch } = this.props;
    dispatch(exportCarbonListExcelBase64String());
  }

  _renderSide = () => (
    <RenderRightHeader>
      {/* <StyledButton type="button" onClick={this._toggleShowCertificateModal}>
        Meu Certificado
      </StyledButton> */}
      {/* <StyledButtonSecondary type="button" onClick={this._toggleShowCarbonCreditModal}>
        Meu Crédito de Carbono
      </StyledButtonSecondary> */}
      <StyledButtonSecondary type="button" onClick={this._handleExportCte}>
        Exportar CTEs
      </StyledButtonSecondary>
    </RenderRightHeader>
  );

  _formatTotalValues(value) {
    const numberValue = Number(value);

    return numberValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  _formatTotalCarbonEmissionValues(value) {
    const numberValue = Number(value);

    return numberValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 10,
      maximumFractionDigits: 10
    });
  }

  _renderCarbonEmissionsHeader() {
    return (
      <CarbonEmissionsHeader>
        <SubHeader
          title="Emissões de CO2"
          renderSide={this._renderSide}
        />
        <CarbonFilters />
      </CarbonEmissionsHeader>
    )
  }

  render() {
    const { paginationOptions } = this.state;
    const { pageLimit, currentPage, carbonListErrorMessage, carbonListLastUpdate, carbonData, carbonDataList, isFetching } = this.props;
    const hasCarbonListErrorMessage = !isFetching && String(carbonListErrorMessage).length > 0 || !carbonData;

    if (isFetching) {
      return (
        <>
          {this._renderCarbonEmissionsHeader()}
          <SecondaryContainer>
            <LoadingIndicator text="Carregando..." theme="dark" noScrollLock />
          </SecondaryContainer>
        </>
      )
    }

    if (hasCarbonListErrorMessage) {
      const formattedDate = format(new Date(carbonListLastUpdate), "'Última atualização em' dd/MM/yyyy 'às' HH:mm") ?? '';
      const { history } = this.props;

      return (
        <>
          {this._renderCarbonEmissionsHeader()}
          <LastUpdateText>{formattedDate}</LastUpdateText>
          <SecondaryContainer>
            <img src={WarningIcon} alt='Warning' width={88} height={88} />
            <Typography>{carbonListErrorMessage}</Typography>
            <StyledButton onClick={() => history.go(0)}>
              <RefreshOutlined /> Recarregar
            </StyledButton>
          </SecondaryContainer>
        </>
      )
    }

    return (
      <div style={{ overflowX: 'hidden' }}>
        {this._renderCarbonEmissionsHeader()}

        <Wrapper>
          <Title>Totalizadores</Title>

          <CardContainer>
            <DefaultCarbonCard iconPath={TruckIcon} title="KM Rodados Totais" contentText={this._formatTotalValues(carbonData.totalKilometersDriven)} secondContentText="KM" />
            <DefaultCarbonCard iconPath={GlobalIcon} title="Emissão de Carbono Total" contentText={this._formatTotalCarbonEmissionValues(carbonData.totalCarbonEmission)} secondContentText="T. CO2 EQ." />
            <DefaultCarbonCard iconPath={ForestIcon} title="Crédito de Carbono Gerado" contentText={'***'} secondContentText="RCE" />
            {carbonData.totalCarbonRatioStatus === CARBON_RATIO_STATUS.BAD && (
              <DefaultCarbonCard iconPath={TrackRedIcon} title="Proporção de CO2" contentText={carbonData.totalCarbonRatio} secondContentText="RUIM" condition={CARD_CONDITION_ENUM.BAD} />
            )}
            {carbonData.totalCarbonRatioStatus === CARBON_RATIO_STATUS.NORMAL && (
              <DefaultCarbonCard iconPath={TrackYellowIcon} title="Proporção de CO2" contentText={carbonData.totalCarbonRatio} secondContentText="NORMAL" condition={CARD_CONDITION_ENUM.NORMAL} />
            )}
            {carbonData.totalCarbonRatioStatus === CARBON_RATIO_STATUS.GOOD && (
              <DefaultCarbonCard iconPath={TrackGreenIcon} title="Proporção de CO2" contentText={carbonData.totalCarbonRatio} secondContentText="BOA" condition={CARD_CONDITION_ENUM.GOOD} />
            )}
          </CardContainer>

          <Title>Lista de NFse</Title>

          <CarbonTable data={carbonDataList} titleOptions={TitleOptions} />

          <Pagination
            options={paginationOptions}
            currentPage={currentPage}
            pageLimit={pageLimit}
            totalItems={carbonData.listTotalItems}
            onChangePage={this._changePage}
            onPageLimitChange={this._changePageLimit}
          />
        </Wrapper>

        {this.state.showCertificateModal && (
          <div>
            <CertificateOfNeutralizationModal data={carbonData} toggleShowCertificateModal={this._toggleShowCertificateModal} />
          </div>
        )}

        {this.state.showCarbonCreditModal && (
          <Modal
            title="Utilizar crédito de carbono"
            size="large"
            hasClose
            onBackdropClick={this._toggleShowCarbonCreditModal}
            secondaryHeader
          >
            <CarbonCreditModal>
              <CarbonCreditModalText>
                Atenção! Para utilizar seu crédito de carbono, você será redirecionado para uma página externa de compensação de carbono. Tem certeza de que deseja prosseguir?
              </CarbonCreditModalText>

              <CarbonCreditModalButtons>
                <CancelButton onClick={this._toggleShowCarbonCreditModal}>
                  Cancelar
                </CancelButton>
                <DefaultButton onClick={this._carbonCreditTab}>
                  Continuar
                </DefaultButton>
              </CarbonCreditModalButtons>
            </CarbonCreditModal>
          </Modal>
        )}

      </div>
    );
  }
}

// Redux

const mapStateToProps = state => {
  return {
    roles: state.auth.roles,
    pageLimit: state.carbon.filters.amount,
    currentPage: state.carbon.filters.page,
    loggedCompanyId: state.auth.activeCompanyId,
    carbonListErrorMessage: state.carbon.carbonList.error,
    carbonListLastUpdate: state.carbon.carbonList.requested,
    carbonData: state.carbon.carbonList.data,
    carbonDataList: state.carbon.carbonList.data?.list,
    isFetching: state.carbon.carbonList.isFetching,
  }
};

export default connect(mapStateToProps)(CarbonEmissions);
